import PropTypes from 'prop-types';
import React from 'react';
import { Tooltip, Chip } from '@weezevent/nacre';

import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import useAppContext from '../../context/useAppContext';

import Styles from '../../styles/rate/rateList.module.css';

export default function RateTemplateTooltip({ template, toRatePage = true }) {
    const { t } = useTranslation();
    const [{ organization }] = useAppContext();

    return (
        <Link target="_blank" to={`/ticket/O${organization.id}/rates/${toRatePage ? template['uuid'] : ''}`}>
            <Tooltip triggerOnHover={true} title={t('ticket.rates.editTemplate')} className={Styles['rate-template-tooltip']}>
                <div className={Styles['rate-template-info']}>
                    <Chip primary icon="link" />
                </div>
            </Tooltip>
        </Link>
    );
}

RateTemplateTooltip.propTypes = {
    template: PropTypes.object.isRequired,
    toRatePage: PropTypes.bool.isRequired
};
